import * as React from 'react';
import { OTPInput, OTPInputContext, REGEXP_ONLY_DIGITS } from 'input-otp';

import { cn } from './cn';

// Closed OTP entry primitive — caller passes `length`, `value`, `onChange`.
// Slots are rendered internally; pattern is fixed to digits-only because
// that's the only OTP shape we send (numeric codes via email).

const SLOT_CLASSNAME = 'tw-relative tw-flex tw-h-10 tw-w-10 tw-flex-none tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid tw-border-input tw-bg-accent tw-text-sm';
const ACTIVE_SLOT_CLASSNAME = 'tw-z-10 tw-border-muted-foreground tw-bg-background';

const Slot = ({ index }) => {
    const ctx = React.useContext(OTPInputContext);
    const slot = ctx?.slots?.[index];

    if (!slot) {
        return null;
    }

    const { char, hasFakeCaret, isActive } = slot;

    return (
        <div className={cn(SLOT_CLASSNAME, isActive && ACTIVE_SLOT_CLASSNAME)}>
            {char}
            {hasFakeCaret && (
                <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                    <div className="tw-h-4 tw-w-px tw-animate-caret-blink tw-bg-foreground tw-duration-1000" />
                </div>
            )}
        </div>
    );
};

const InputOTP = React.forwardRef(({
    className: _className,
    style: _style,
    length,
    onChange,
    value
}, ref) => (
    <OTPInput
        ref={ref}
        containerClassName="tw-flex tw-items-center tw-gap-4"
        maxLength={length}
        onChange={onChange}
        pattern={REGEXP_ONLY_DIGITS}
        value={value}
    >
        {Array.from({ length }, (_, index) => <Slot key={index} index={index} />)}
    </OTPInput>
));

InputOTP.displayName = 'InputOTP';

export { InputOTP };
